import React from "react";
import PropTypes from 'prop-types';
import './styles/clipboard_copy';

export default class ClipboardCopy extends React.Component {
  state = {
    copied: false
  };

  copyToClipboard() {
    const textField = document.createElement('textarea');
    textField.innerText = this.props.textToCopy;

    document.body.appendChild(textField);
    textField.select();

    document.execCommand('copy');

    // Need this because IE11 doesn't support javascript .remove()
    if (!('remove' in Element.prototype)) {
      Element.prototype.remove = () => {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      };
    }

    textField.remove();


    this.setState({ copied: true }, () => setTimeout(() => this.setState({ copied: false }), 2000));
  }

  renderFeedbackAsTooltip() {
    if (this.state.copied) {
      return (
        <span className="feedback-as-tooltip-container">
          <span className="feedback-as-tooltip">{t('Copied!')}</span>
          {this.props.children}
        </span>
      );
    }

    return this.props.children;
  }

  renderFeedbackAsReplacement() {
    if (this.state.copied) {
      return <span className="bff-check-mark feedback-as-replacement" aria-label="copied" />;
    }

    return this.props.children;
  }

  render() {
    return (
      <span
        className={`clipboard-copy-component ${this.props.needIcon ? `bff-copy` : ''}`}
        onClick={(e) => this.copyToClipboard(e)}
        rel={this.props.needIcon ? "tooltip" : undefined}
        title={this.props.needIcon ? "Copy to Clipboard" : undefined}
      >
        {this.props.showFeedbackAsTooltip
          ? this.renderFeedbackAsTooltip()
          : this.renderFeedbackAsReplacement()
        }
      </span>
    );
  }
}

ClipboardCopy.propTypes = {
  showFeedbackAsTooltip: PropTypes.bool,
  textToCopy: PropTypes.string,
  needIcon: PropTypes.bool
};

ClipboardCopy.defaultProps = {
  showFeedbackAsTooltip: true,
  textToCopy: null,
  needIcon: false
};
